import 'regenerator-runtime/runtime';
import { delay, put } from 'redux-saga/effects';
import { sessionExpired } from '../local.actions';

export const TIME_UNTIL_SESSION_ENDS_MS = 14400000; // 4h in milliseconds

export function* sessionExpiresSaga() {
  yield delay(TIME_UNTIL_SESSION_ENDS_MS);
  yield put(sessionExpired());
}
